module.exports = __webpack_public_path__ + "static/img/setBackground.a915ed96.svg";